interface VideoPlayerFallbackProps {
    isMainVideoPage?: boolean;
}

export const VideoPlayerFallback = (props: VideoPlayerFallbackProps) => {
    return (
        <div className={`responsive-container skeleton ${props.isMainVideoPage ? "main" : ""}`}/>
    );
}